// The "Registra CRD (da RVFU)" dialog and the CRD step of the PRA case (Stage 2 slice 4). Plain
// module with no Vue, so it runs under `node --test`. Labels are i18n keys; the API checks
// everything again (number, dates, file, uniqueness).

import { todayRome } from "./draftForm.mjs";
import { checkUpload } from "./dossierFiles.mjs";

// Same limit as the API (pra/manualConnector.js).
export const CRD_NUMBER_MAX = 100;

export function emptyCrdForm() {
  return { number: "", issuedOn: "", file: null };
}

// The date issued goes from the arrival date to today in Europe/Rome (both included).
export function crdDateLimits({ arrivalDate, now = new Date() }) {
  return { min: arrivalDate || "", max: todayRome(now) };
}

// { field: reason } for what blocks the save; {} when it can be sent. "required" only disables the
// button; the other reasons show under the field.
export function crdFormErrors(form, limits) {
  const errors = {};
  const number = String((form && form.number) || "").trim();
  if (!number) errors.number = "required";
  else if (number.length > CRD_NUMBER_MAX) errors.number = "too_long";
  const date = (form && form.issuedOn) || "";
  if (!date) errors.issuedOn = "required";
  else if (limits.min && date < limits.min) errors.issuedOn = "before_arrival";
  else if (limits.max && date > limits.max) errors.issuedOn = "in_future";
  if (!form || !form.file) errors.file = "required";
  else {
    const problem = checkUpload(form.file, "pra");
    if (problem) errors.file = problem;
  }
  return errors;
}

// "212 KB", "1.4 MB" for the file chip.
export function formatFileSize(bytes) {
  const size = Number(bytes) || 0;
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${Math.round(size / 1024)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

// One commandId per CRD: a retry of the same input reuses it, so a double click records it once.
export function crdSubmitKey(form) {
  const file = form.file || {};
  return [
    String(form.number).trim(),
    form.issuedOn,
    file.name,
    file.size,
    file.lastModified,
  ].join("|");
}

// The "Registra CRD (da RVFU)" button: shown while the case waits for the CRD, disabled on hold.
export function crdAction(view) {
  const praCase = view && view.praCase;
  if (!praCase || view.nextStep !== "crd") return null;
  return { disabled: Boolean(praCase.activeHold) };
}

// A failed CRD save -> acceptance.pra.crd.errors.<key>, or null to show the API's errorMsg.
const CRD_ERROR_CODES = [
  "crd_number_in_use",
  "date_order",
  "date_in_future",
  "file_required",
  "unsupported_type",
  "step_out_of_order",
  "already_confirmed",
  "case_on_hold",
];

export function crdErrorKey(err) {
  const res = err && err.response;
  if (!res) return null;
  // A proxy in front of the API may answer 413 without our JSON body.
  if (res.status === 413) return "too_large";
  const code = res.data && res.data.code;
  return CRD_ERROR_CODES.includes(code) ? code : null;
}
